import { withTranslation } from "react-i18next";

import SupplierList from './SupplierList';

export default withTranslation(undefined, { withRef: true })(SupplierList);